var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChef(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "avatar/users/chef") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 70 56 70 56 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "avatar/users/chef",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(15.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,48.0903 C42.484,44.2493 33.979,42.0683 24.96,42.0683 C15.973,42.0683 7.496,44.2333 0,48.0483 L0,66.0003 L50,66.0003 L50,48.0903 Z",
    id: "Fill-1",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.96,42.0684 C33.98,42.0684 42.484,44.2494 50,48.0904 L50,66.0004 L12,66.0004 L12,47.0004 L25,47.0004 L24.96,42.0684 Z",
    id: "Fill-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,28 L14,28 C12.896,28 12,27.104 12,26 L12,23 C12,21.896 12.896,21 14,21 L36,21 C37.104,21 38,21.896 38,23 L38,26 C38,27.104 37.104,28 36,28",
    id: "Fill-5",
    fill: "#785716"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,42.6543 C18.167,44.9163 21.312,47.0003 25,47.0003 C28.875,47.0003 31.458,45.2083 33,42.6543 L33,32.2963 L17,32.2963 L17,42.6543 Z",
    id: "Fill-7",
    fill: "#785716"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.958,29 C35.958,35.075 31.033,40 24.958,40 C18.883,40 14,35.075 14,29 L14,20.025 L35.958,20.025 L35.958,29 Z",
    id: "Fill-9",
    fill: "#91682E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,7 C32,10.866 28.866,14 25,14 C21.134,14 18,10.866 18,7 C18,3.134 21.134,0 25,0 C28.866,0 32,3.134 32,7",
    id: "Fill-11",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,10 C21,13.313 18.313,16 15,16 C11.687,16 9,13.313 9,10 C9,6.687 11.687,4 15,4 C18.313,4 21,6.687 21,10",
    id: "Fill-13",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,10 C41,13.313 38.313,16 35,16 C31.687,16 29,13.313 29,10 C29,6.687 31.687,4 35,4 C38.313,4 41,6.687 41,10",
    id: "Fill-15",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-18"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-17",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "14 21 36 21 36 6 14 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,31.9409 C25,30.8859 24.104,30.0309 23,30.0309 C22.272,30.0309 21.687,30.4489 21.247,31.0349 C20.683,31.7859 19.688,33.0449 18.094,33.4329 C19.483,33.8749 21.908,34.2179 23.367,33.8159 C24.188,33.5879 25,32.8389 25,31.9409",
    id: "Fill-19",
    fill: "#000000",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,31.9409 C25,30.8859 25.896,30.0309 27,30.0309 C27.728,30.0309 28.313,30.4489 28.753,31.0349 C29.317,31.7859 30.312,33.0449 31.906,33.4329 C30.517,33.8749 28.092,34.2179 26.633,33.8159 C25.812,33.5879 25,32.8389 25,31.9409",
    id: "Fill-20",
    fill: "#000000",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,56.1567 L50,48.9997 L48,48.9997 L48,47.1387 C47.34,46.8347 46.674,46.5457 46,46.2667 L46,48.9997 L44,48.9997 L44,45.4657 C43.341,45.2217 42.671,45.0037 42,44.7847 L42,48.9997 L40,48.9997 L40,44.1787 C39.336,43.9897 38.674,43.7937 38,43.6297 L38,54.9997 L43,57.8237 L43,65.9997 L47,65.9997 L47,57.8917 L50,56.1567 Z",
    id: "Fill-21",
    fillOpacity: 0.2,
    fill: "#000000",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,44 L54,44 L54,34 L52,34 L52,44 Z M44,44 L46,44 L46,34 L44,34 L44,44 Z M48,44 L50,44 L50,34 L48,34 L48,44 Z M56,32 L42,32 L42,50 L47,52.824 L47,70 L51,70 L51,52.892 L56,50 L56,32 Z",
    id: "Fill-22",
    fill: "#777A80",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,52 C18,52.552 17.553,53 17,53 C16.447,53 16,52.552 16,52 C16,51.448 16.447,51 17,51 C17.553,51 18,51.448 18,52",
    id: "Fill-23",
    fill: "#313036",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,57 C18,57.552 17.553,58 17,58 C16.447,58 16,57.552 16,57 C16,56.448 16.447,56 17,56 C17.553,56 18,56.448 18,57",
    id: "Fill-24",
    fill: "#313036",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,62 C18,62.552 17.553,63 17,63 C16.447,63 16,62.552 16,62 C16,61.448 16.447,61 17,61 C17.553,61 18,61.448 18,62",
    id: "Fill-25",
    fill: "#313036",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,23 C21,23.552 20.553,24 20,24 C19.447,24 19,23.552 19,23 C19,22.448 19.447,22 20,22 C20.553,22 21,22.448 21,23",
    id: "Fill-26",
    fill: "#000000",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,23 C31,23.552 30.553,24 30,24 C29.447,24 29,23.552 29,23 C29,22.448 29.447,22 30,22 C30.553,22 31,22.448 31,23",
    id: "Fill-27",
    fill: "#000000",
    mask: "url(#mask-2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChef);
export default __webpack_public_path__ + "static/media/chef.790ffeceb853e015e0ce5deb988e65dd.svg";
export { ForwardRef as ReactComponent };